import { render } from "./ResubscribeModal.vue?vue&type=template&id=5802d5b0&scoped=true"
import script from "./ResubscribeModal.vue?vue&type=script&lang=js"
export * from "./ResubscribeModal.vue?vue&type=script&lang=js"

import "./ResubscribeModal.vue?vue&type=style&index=0&id=5802d5b0&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5802d5b0"]])

export default __exports__